<script>
// 仅导入父组件，无需导入Draw
import DrawBase from './drawBase.vue';
import UtilS from '@/utils/MapUtil.js';

export default {
    extends: DrawBase,
    render() {
        return null;
    },
    watch: {
        selectLDrawType: {
            handler(type) {
                if (this.geometryType === 'Point' && type) {
                    this.initMap()
                        .then(() => {
                            if (this.map && this.VectorSource) {
                                this.onAddInteraction();
                            } else {
                                console.error('地图或数据源初始化失败，无法创建Draw交互');
                            }
                        })
                        .catch((err) => {
                            console.error('初始化地图失败：', err);
                        });
                }
            },
            immediate: true,
        },
    },
    methods: {
        // Point专用样式函数
        styleFunction(feature) {
            const type = this.selectLDrawType;
            const iconObj = this.srcFilterFn(type);

            return this.createOLStyle({
                stroke: type === 'dangerPoint' || type === 'firePoint'
                    ? this.createOLStroke({ color: '#00FF00', width: 4 })
                    : null,
                image: this.createOLIcon(iconObj),
            });
        },

        // Point绘制交互（调用父组件createOLDraw方法）
        onAddInteraction() {
            if (!this.map) return;
            if (!this.VectorSource) {
                this.VectorSource = this.createOLVectorSource({ wrapX: false });
            }

            this.removeDraw();

            try {
                // 调用父组件封装的Draw创建方法
                this.draw = this.createOLDraw({
                    type: 'Point',
                    style: this.styleFunction.bind(this),
                });

                this.map.addInteraction(this.draw);
                this.bindDrawEndEvent();
            } catch (err) {
                this.draw = null;
            }
        },

        // 绘制完成事件逻辑
        bindDrawEndEvent() {
            this.draw.on('drawend', async (e) => {
                try {
                    const Coordinates = e.feature.getGeometry().getCoordinates();

                    // 危险点逻辑
                    if (this.selectLDrawType === 'dangerPoint') {
                        this.$emit('addDataEvent', {
                            name: '',
                            location: '',
                            area: '',
                            longitude: Coordinates[0],
                            latitude: Coordinates[1],
                            type: this.selectLDrawType,
                        }, 'case');
                        this.emitParentEvents();
                        this.removeDraw();
                        return;
                    }

                    // 火情点逻辑
                    if (this.selectLDrawType === 'firePoint') {
                        e.feature.setId(Coordinates);
                        this.$emit('addDataEvent', {
                            name: `燃烧点-${new Date().getTime()}`,
                            geometryType: 'Point',
                            geometry: UtilS.pointToWKT(Coordinates[0], Coordinates[1]),
                        }, 'canvas');
                    }

                    // 交通管制相关点
                    let params = null;
                    // eslint-disable-next-line default-case
                    switch (this.selectLDrawType) {
                        case 'Traffic-start':
                            params = {
                                drawType: 'Point',
                                drawName: '标记管制路段-起点',
                                drawObj: '管制路段-起点',
                                mark: '起点',
                                longitude: Coordinates[0],
                                latitude: Coordinates[1],
                            };
                            break;
                        case 'Traffic-end':
                            params = {
                                drawType: 'Point',
                                drawName: '标记管制路段-终点',
                                drawObj: '管制路段-终点',
                                mark: '终点',
                                longitude: Coordinates[0],
                                latitude: Coordinates[1],
                            };
                            break;
                        case 'Traffic-kakou':
                            params = {
                                drawType: 'Point',
                                drawName: '标记管制路段-卡口',
                                drawObj: '管制路段-卡口',
                                mark: '卡口',
                                longitude: Coordinates[0],
                                latitude: Coordinates[1],
                            };
                            break;
                        case 'suspicion-user':
                            params = {
                                drawType: 'Point',
                                drawName: '标记标记嫌疑人',
                                drawObj: '标记嫌疑人',
                                mark: '嫌疑人',
                                longitude: Coordinates[0],
                                latitude: Coordinates[1],
                            };
                            break;
                    }

                    if (params) {
                        await this.saveDrawInfo(params);
                    }

                    this.emitParentEvents();
                    this.removeDraw();
                } catch (err) {
                    console.error('处理绘制完成事件失败：', err);
                }
            });
        },
    },
};
</script>
